export enum Estados {

  /** Cotizacion */
  Cotizacion = -9999,

  /** Cotizacion */
  Seguimiento1 = -9901,

  /** Cotizacion */
  Seguimiento2 = -9902,

  /** Cotizacion */
  Seguimiento3 = -9903,
  


  /** Pago Anulado */
  Anulado = -10,

  /** Operación con pago rechazado */
  Rechazado = -2,

  /** Operación Cerrada antes de ser Pagada */
  Cerrado = -1,
  
  /** En proceso de Pago en el Gateway */
  Cobrando = 5,

  /** Pendiente de Pago - Requiere atención humana para efectuar el pago */
  Pendiente = 0,

  /** Verificar Pago - Se debe verificar el pago manualmente */
  VerificarPago = 1500,
  
  /** Operación Pagada - Procesar la Emisión del Voucher */
  Emitir = 1,

  /** Operación Pagada - Error emitiendo el Voucher o Informando a Sistema de Externo */
  ErrorEmitiendo = -3,

  /** Error enviando el Voucher al Pasajero */
  ErrorEnviarVoucher = -4,

  /** Proceso de Voucher finalizado con éxito - pendiente de facturación */
  Emitido = 2,

  /** Comisión calculada, listo para facturar */
  Facturar = 3,

  /** Operación ya facturada (facturación+conciliación) */
  Facturado = 4,

  /** Operación ya facturada y devuelta */
  Devuelto = 9300,

  /** Estado final exitoso y facturado */
  Finalizado = 10
}
